import type { SettingsTabId } from '@/types/settings';

/** Warm a settings tab JS chunk (sidebar hover, etc.). */
export const SETTINGS_TAB_PRELOAD: Partial<Record<SettingsTabId, () => void>> = {
  general: () => void import('./tabs/GeneralTab'),
  team: () => void import('./tabs/TeamTab'),
  auth: () => void import('./tabs/AuthTab'),
  'code-management': () => void import('./tabs/CodeManagement'),
  'code-review-settings': () => void import('./tabs/PrSettingsTab'),
  api: () => void import('./tabs/ApiTab'),
  billing: () => void import('../Profile/Billing'),
  'slack-notification': () => void import('./tabs/SlackTab'),
};
